import { useEffect, useState } from "react";
import { Toast, ToastContainer } from "react-bootstrap";
import {
  CheckCircleFilled,
  CloseCircleFilled,
  ExclamationCircleFilled,
  InfoCircleFilled,
  CloseOutlined,
} from "@ant-design/icons";
import { subscribeToasts } from "./notify";
import logo from "../../assets/img/logo - copia.png";
import "../toasts/toast.css";

const ICON_BY_TYPE = {
  success: <CheckCircleFilled />,
  error: <CloseCircleFilled />,
  warning: <ExclamationCircleFilled />,
  info: <InfoCircleFilled />,
};

const TITLE_BY_TYPE = {
  success: "Éxito",
  error: "Error",
  warning: "Atención",
  info: "Información",
};

const DEFAULT_PLACEMENT = "bottomRight";

const POSITION_STYLE_BY_PLACEMENT = {
  topRight: { top: 4, right: 16, left: "auto", bottom: "auto" },
  topLeft: { top: 4, left: 16, right: "auto", bottom: "auto" },
  bottomRight: { bottom: 4, right: 4, left: "auto", top: "auto" },
  bottomLeft: { bottom: 4, left: 4, right: "auto", top: "auto" },
};

// Móntalo una sola vez, en el shell global de la app (electron_view.js / index.js).
// A partir de ahí, cualquier archivo (componente o redux thunk) puede llamar
// notify.success(...) / notify.error(...) importando "./notify".
export default function ToastHost() {
  const [toasts, setToasts] = useState([]);

  useEffect(() => {
    return subscribeToasts((toast) => {
      setToasts((prev) => [...prev, toast]);
    });
  }, []);

  // Apagado suave: primero se marca "closing" (dispara la animación de
  // salida en CSS) y solo hasta que esa animación termina se quita del
  // array — si se quitara de inmediato, el toast desaparecería de golpe.
  const close = (id) => {
    setToasts((prev) => prev.map((t) => (t.id === id ? { ...t, closing: true } : t)));
    setTimeout(() => {
      setToasts((prev) => prev.filter((t) => t.id !== id));
    }, 260);
  };

  // Agrupa por placement para poder tener varios ToastContainer, uno por
  // esquina, ya que cada toast puede pedir una posición distinta.
  const groups = new Map();
  toasts.forEach((t) => {
    const key = POSITION_STYLE_BY_PLACEMENT[t.placement] ? t.placement : DEFAULT_PLACEMENT;
    if (!groups.has(key)) groups.set(key, []);
    groups.get(key).push(t);
  });

  return (
    <>
      {Array.from(groups.entries()).map(([placement, group]) => (
        <ToastContainer
          key={placement}
          className={`eh-toast-container eh-toast-container--${placement} p-2`}
        >
          {group.map((t) => (
            <Toast
              key={t.id}
              onClose={() => close(t.id)}
              show
              delay={4500}
              autohide
              className={`eh-toast eh-toast-${t.type || "info"}${t.closing ? " eh-toast-closing" : ""}`}
            >
              <Toast.Body className="eh-toast-body">
                <span className="eh-toast-icon">
                  <img src={logo} alt="" className="eh-toast-logo" />
                  <span className="eh-toast-badge">
                    {ICON_BY_TYPE[t.type] || ICON_BY_TYPE.info}
                  </span>
                </span>

                <span className="eh-toast-msg">
                  {t.message || TITLE_BY_TYPE[t.type]}
                  {t.description ? <div>{t.description}</div> : null}
                </span>

                <button
                  type="button"
                  className="eh-toast-close"
                  onClick={() => close(t.id)}
                  aria-label="Cerrar"
                >
                  <CloseOutlined />
                </button>

                <span className="eh-toast-progress" />
              </Toast.Body>
            </Toast>
          ))}
        </ToastContainer>
      ))}
    </>
  );
}
